/* RESPONSIBLE TEAM: team-workflows */
import Step, { IsCustomerFacing } from 'embercom/models/operator/visual-builder/step';
import type Store from '@ember-data/store';
import { buildValidations, validator } from 'ember-cp-validations';
import { fragment } from 'ember-data-model-fragments/attributes';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';

const Validations = buildValidations({
  action: [
    validator('presence', true),
    validator('rule-action-is-valid', {
      message: 'operator.workflows.visual-builder.validations.empty-action-error',
    }),
  ],
});

export default class RemoveTagFromConversation extends Step.extend(Validations) {
  @fragment('rules/rule-action') declare action: any;

  get supportedChannels() {
    return SUPPORTED_CHANNELS.removeTagFromConversation;
  }

  static get isStepGroupEnding() {
    return false;
  }

  static createNewStep(store: Store): RemoveTagFromConversation {
    return store.createRecord('operator/visual-builder/step/remove-tag-from-conversation', {
      action: store.createFragment('rules/rule-action', {
        type: 'remove-tag-from-conversation',
        justAdded: true,
        actionData: {},
      }),
      type: 'operator/visual-builder/step/remove-tag-from-conversation',
    });
  }

  static get canBeCustomerFacing() {
    return IsCustomerFacing.No;
  }
}
